export default function Notifications() {
  return (
    <div className="bg-white shadow rounded-lg p-6">
      <h2 className="text-xl font-semibold mb-4">🔔 Notifications</h2>
      <p>All updates from the QEVRIX team will be displayed here.</p>
    </div>
  );
}
